import filter from 'lodash/filter'

export function filterBySeasonId(items, seasonId) {
  return filter(items, { seasonId })
}

export function filterByLocationId(items, locationId) {
  return filter(items, { locationId })
}

export function filterByIds(items, ids) {
  const uniqueIds = [...new Set(ids)]
  return filter(items, (item) => uniqueIds.includes(item._id))
}
